<script setup lang="ts">
const { t } = useTexts();
const { brandContacts } = useFeatureFlagsNew();

const customerServiceLink = computed<string>(() => {
  return brandContacts.value?.customer_service?.link || '';
});

const complaintsLink = computed<string>(() => {
  return brandContacts.value?.complaints?.link || '';
});

const supportLink = computed<string>(() => {
  // TODO: mudar para o link de privacidade
  return brandContacts.value?.support?.link || '';
});

const supportText = computed<string>(() => {
  return t('footer.support_player');
});

const supportEmail = computed<string>(() => {
  const email = brandContacts.value?.support?.email || '';

  if (email && isEmailValid(email)) {
    return email;
  }

  return '';
});

const isNewInfosEnabled = computed<boolean>(() => {
  return !!customerServiceLink.value && !!supportLink.value;
});

// OLD component code bellow
const appearance = useAppearanceStore();

const emailSupport = computed(() => {
  let email = appearance.appearance?.footer_emails?.SUPPORT_EMAIL || '';

  if (email && isEmailValid(email)) {
    email = email.replace('{site_url}', appUrl());

    return email;
  }

  return '';
});

const emailLegal = computed(() => {
  let email = appearance.appearance?.footer_emails?.LEGAL_EMAIL || '';

  if (email && isEmailValid(email)) {
    email = email.replace('{site_url}', appUrl());

    return email;
  }

  return '';
});

const emailPartners = computed(() => {
  let email = appearance.appearance?.footer_emails?.PARTNER_EMAIL || '';

  if (email && isEmailValid(email)) {
    email = email.replace('{site_url}', appUrl());

    return email;
  }

  return '';
});

const hasAnyOldEmail = computed(() => {
  return !!emailSupport.value || !!emailLegal.value || !!emailPartners.value;
});
</script>

<template>
  <div
    v-if="isNewInfosEnabled"
    :class="$style.footerEmails"
  >
    <template v-if="customerServiceLink">
      <a
        :class="[$style.link, $style.section]"
        :href="customerServiceLink"
        target="_blank"
      >
        <span>{{ $t('footer.customer_service_office') }} </span>
      </a>
    </template>

    <template v-if="complaintsLink">
      <a
        :class="[$style.link, $style.section]"
        :href="complaintsLink"
        target="_blank"
      >
        <span>{{ $t('footer.complaints') }} </span>
      </a>
    </template>

    <template v-if="supportLink">
      <a
        :class="[$style.link, $style.section]"
        :href="supportLink"
        target="_blank"
      >
        <span>{{ supportText }} </span>
      </a>
    </template>

    <template v-if="supportEmail">
      <p :class="$style.section">
        <span>
          {{ $t('footer.support') }}
        </span>

        <a
          :class="$style.link"
          :href="`mailto:${supportEmail}`"
        >
          <span>{{ supportEmail }}</span>
        </a>
      </p>
    </template>
  </div>

  <div
    v-else-if="hasAnyOldEmail"
    :class="$style.footerEmails"
  >
    <template v-if="emailSupport">
      <p :class="$style.section">
        <span>
          {{ $t('footer.support') }}
        </span>

        <a
          :class="[$style.link, $style.email]"
          :href="`mailto:${emailSupport}`"
        >
          <span>{{ emailSupport }}</span>
        </a>
      </p>
    </template>

    <template v-if="emailLegal">
      <p :class="$style.section">
        <span>
          {{ $t('footer.legal') }}
        </span>

        <a
          :class="$style.link"
          :href="`mailto:${emailLegal}`"
        >
          <span>{{ emailLegal }}</span>
        </a>
      </p>
    </template>

    <template v-if="emailPartners">
      <p :class="$style.section">
        <span>
          {{ $t('footer.partners') }}
        </span>

        <a
          :class="$style.link"
          :href="`mailto:${emailPartners}`"
        >
          <span>{{ emailPartners }}</span>
        </a>
      </p>
    </template>
  </div>
</template>

<style module lang="scss">
.footerEmails {
  @apply text-[.65rem] md:text-[.7rem] text-footer-titles text-center flex justify-center items-center w-full pb-1 md:pb-2 flex-wrap gap-x-5 gap-y-2.5 sm:gap-x-1 sm:gap-y-1 px-4;
}

.section {
  @apply flex gap-1;

  & ~ .section::before {
    @apply mx-1 w-1 text-footer-texts opacity-20 inline-flex max-sm:hidden font-light;
    content: '|';
  }
}

.link {
  @apply underline font-bold text-primary inline-flex;
}
</style>
